export const Experiments = {
  CommentsRedesign: 'exp2605-comments-redesign',
  HideEventBeforeLoginAb: 'exp2601-hide-event-before-login-ab',
  SsrRendererService: 'exp2601-ssr-renderer-service',
  SeoHeaderH1H2: 'exp2604-seo-header-h1h2',
  HomeInputboxRefresh: 'exp2604-home-inputbox-refresh',
  WaitTimeHint: 'exp2604-low-priority-wait-time',
  ArtworkTacksPagination: 'exp2605-artwork-tacks-pagination-v3',
  ContestV2: 'exp2604-contest-v2-web',
  HideMembershipBannerLoggedOut: 'exp2605-hide-membership-banner-logged-out',
  OnboardingInGenerationPanel: 'exp2605-onboarding-in-generation-panel',
  PaymentMethodPage: 'exp2605-payment-method-page',
  SearchBarAutocomplete: 'exp2605-search-bar-autocomplete',
} as const
